<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="订单详情"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="order-content">
      <div class="order-status">待付款</div>
      <div class="order-title">商品信息</div>
      <div class="goods-list">
        <div class="hd">
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            src="https://img.yzcdn.cn/vant/cat.jpeg"
          />
        </div>
        <div class="bd">
          <div class="title">
            <h2 class="name">清明节鲜花祭祀黄白菊</h2>
            <span class="num">x1</span>
            <div class="price">￥119.0</div>
          </div>
        </div>
      </div>
      <van-divider />
      <div class="goods-info-item">
        <div class="hd">共2件商品</div>
        <div class="bd">¥50</div>
      </div>
      <van-divider />
      <div class="goods-info-item">
        <div class="hd">合计</div>
        <div class="bd">¥100</div>
      </div>
      <van-divider />
      <div class="order-title">订单信息</div>
      <div class="order-info-item">
        <div class="hd">订单编号:</div>
        <div class="bd">1256324856942</div>
      </div>
      <div class="order-info-item">
        <div class="hd">下单时间:</div>
        <div class="bd">2018/08/26 12:20</div>
      </div>
      <div class="order-info-item">
        <div class="hd">支付方式:</div>
        <div class="bd">在线支付/支付宝</div>
      </div>
      <div class="order-info-item">
        <div class="hd">配送方式:</div>
        <div class="bd">委托祭拜</div>
      </div>
    </div>

    <div class="button-area">
      <van-button type="default" to="/">取消</van-button>
      <van-button color="orange" to="/">付款</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pid: "",
      puid : "",
    };
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.order-content {
  padding: 0 16px;
}
.order-status {
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 30px;
}
.order-title {
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 15px;
}
.goods-list {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.goods-list > .hd {
  width: 50px;
  height: 50px;
  margin-right: 12px;
}
.goods-list > .bd {
  flex: 1;
  overflow: hidden;
}
.goods-list > .bd .title {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.goods-list > .bd .title .name {
  font-size: 14px;
  color: #555;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.goods-list > .bd .title .num {
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}
.goods-list > .bd .title .price {
  font-size: 14px;
  color: crimson;
  margin-left: 10px;
}
.goods-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
}
.goods-info-item > .hd {
  font-size: 14px;
  color: #666;
}
.goods-info-item > .bd {
  flex: 1;
  text-align: right;
  font-size: 14px;
  color: #222;
}
.order-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}
.order-info-item > .hd {
  font-size: 14px;
  color: #888;
  margin-right: 6px;
}
.order-info-item > .bd {
  flex: 1;
  text-align: left;
  font-size: 14px;
  color: #222;
}
</style>
